module.exports = __webpack_public_path__ + "static/blog-06e420fe85f7f8b44756fa7241c0df4c.jpg";